module.exports = __webpack_public_path__ + "static/media/dl.8abd1bec.webp";